import { Injectable } from '@angular/core';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { LocalStorageService } from './local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    permissionArray = [];
    rolesPermissions: any;
    isDpdLogistic: boolean = false;
    isAsendiaUKCustomer: boolean = false;

    constructor(
        private roleService: NgxRolesService,
        private ngxPermissionService: NgxPermissionsService,
        private localStorageService: LocalStorageService
    ) {
        this.isAsendiaUKCustomer = this.localStorageService.get('isAsendiaUserUk');
    }

    initializePermissions(capabilities?) {
        if (capabilities) {
            this.rolesPermissions = capabilities;
            this.mapPermissions();
        } else {
            this.getPermissions();
        }
    }
    mapPermissions() {
        this.flushPermission();
        this.permissionArray = [];
        this.rolesPermissions.map((permission) => {
            this.permissionArray = [
                ...this.permissionArray,
                ...(permission?.access_functions ?? [])
            ];
        });

        this.ngxPermissionService.addPermission(this.permissionArray);
        this.ngxPermissionService.loadPermissions(this.permissionArray);
    }

    getPermissions() {
        this.rolesPermissions = [];
        this.rolesPermissions = this.localStorageService.get('permissionArray');
        if (this.rolesPermissions) {
            this.mapPermissions();
        }
    }

    flushPermission() {
        this.roleService.flushRolesAndPermissions();
        this.ngxPermissionService.flushPermissions();
    }
}
